import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaWordpress,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const WooCommerceWebsiteDesignInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="WooCommerce Website Design in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Power Your Store</Subheading>}
        heading={
          <Heading>
            Expert <span tw="text-primary-500">WooCommerce Website Design</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver WooCommerce website design in
            **DIFC**, creating powerful, scalable, and visually stunning online
            stores that leverage the flexibility of WooCommerce to drive your
            business success in Dubai’s financial hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // WooCommerce store setup
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce development
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your WooCommerce Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier WooCommerce Solutions in DIFC"
        description="We craft WooCommerce stores tailored for success."
        cards={[
          {
            icon: <FaWordpress color="#ff5464" size={40} />,
            title: "WooCommerce Expertise",
            description: "Customized stores with full platform power.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Driven",
            description: "Optimized for conversions and growth.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Professional Design",
            description: "Sleek stores by DIFC’s top developers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast & Scalable",
            description: "High-performance stores that grow.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Seamless shopping on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred for WooCommerce excellence.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our WooCommerce Design Process"
        description={
          <Description>
            We create WooCommerce stores with precision and care:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your DIFC business goals.</li>
              <li>Design: Develop custom, user-friendly layouts.</li>
              <li>Development: Integrate WooCommerce features seamlessly.</li>
              <li>Testing: Ensure flawless functionality and speed.</li>
              <li>Launch: Deliver a polished, scalable store.</li>
              <li>Support: Offer ongoing updates and optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Impact</Subheading>}
        heading="WooCommerce Success in DIFC"
        description="Our stores deliver measurable results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Revenue Growth",
            description: "Tripled sales for a DIFC retailer.",
          },
          {
            icon: <FaWordpress color="#ff5464" size={40} />,
            title: "Seamless Store",
            description: "Custom WooCommerce boosted engagement.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "97% satisfaction from DIFC clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell?</Subheading>}
        heading="WooCommerce Excellence in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for expert WooCommerce website design in
            DIFC. Launch a powerful, tailored store that drives results—contact
            us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
          "https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce success
          "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online store management
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
